import { render } from "./BrandInfo.vue?vue&type=template&id=562d44b0&scoped=true"
import script from "./BrandInfo.vue?vue&type=script&lang=js"
export * from "./BrandInfo.vue?vue&type=script&lang=js"

import "./BrandInfo.vue?vue&type=style&index=0&id=562d44b0&scoped=true&lang=css"

import exportComponent from "/home/entheo/wetouch2_bce_2022/site_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562d44b0"]])

export default __exports__